export const ROLES = {
  super_admin: "Super Admin",
  admin: "Admin",
  operations_manager: "Ops Manager",
  affiliate_manager: "Affiliate Manager",
  client_manager: "Client Manager",
  compliance_manager: "Compliance",
  return_review_manager: "Return Reviewer",
  reporting_user: "Reporting",
  read_only: "Read-Only",
  media_buyer: "Media Buyer",
  client_admin: "Client Admin",
  client_employee: "Client Employee",
  affiliate_admin: "Affiliate Admin",
  affiliate_employee: "Affiliate Employee",
};

export const INTERNAL_ROLES = [
  "super_admin",
  "admin",
  "operations_manager",
  "affiliate_manager",
  "client_manager",
  "compliance_manager",
  "return_review_manager",
  "reporting_user",
  "read_only",
  "media_buyer",
];
export const CLIENT_ROLES = ["client_admin", "client_employee"];
export const AFFILIATE_ROLES = ["affiliate_admin", "affiliate_employee"];

export const EMPLOYEE_STATUSES = [
  "invited",
  "invitation_pending",
  "active",
  "suspended",
  "deactivated",
  "locked",
  "invitation_expired",
  "archived",
];

export const STATUS_COLORS = {
  active: "bg-black text-white",
  archived: "bg-zinc-200 text-zinc-600",
  invited: "bg-yellow-400 text-black",
  invitation_pending: "bg-yellow-400 text-black",
  suspended: "bg-red-600 text-white",
  deactivated: "bg-zinc-500 text-white",
  locked: "bg-red-600 text-white",
  invitation_expired: "bg-red-600 text-white",

  new: "bg-blue-700 text-white",
  validated: "bg-green-700 text-white",
  duplicate: "bg-yellow-400 text-black",
  rejected: "bg-red-600 text-white",
  delivered: "bg-black text-white",
  pending: "bg-yellow-400 text-black",
  scheduled: "bg-amber-100 text-amber-900",
  failed: "bg-red-600 text-white",

  reported: "bg-yellow-400 text-black",
  pending_review: "bg-yellow-400 text-black",
  additional_info_requested: "bg-yellow-400 text-black",
  affiliate_review_requested: "bg-yellow-400 text-black",
  confirmed_bad: "bg-red-600 text-white",
  not_confirmed: "bg-green-700 text-white",
  return_approved: "bg-green-700 text-white",
  return_denied: "bg-red-600 text-white",
  credit_issued: "bg-green-800 text-white",
  replacement_approved: "bg-green-700 text-white",
  replacement_delivered: "bg-green-800 text-white",
  disputed: "bg-red-600 text-white",
  escalated: "bg-red-600 text-white",
  closed: "bg-zinc-800 text-white",
};

export const DATE_RANGES = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "7d", label: "Last 7 days" },
  { key: "30d", label: "Last 30 days" },
  { key: "month", label: "This month" },
  { key: "prev_month", label: "Previous month" },
];

export function labelize(v) {
  if (!v) return "";
  return String(v).replaceAll("_", " ");
}

export function money(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return `$${n.toFixed(2)}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function relTime(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const now = Date.now();
  const s = Math.max(0, Math.round((now - then) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  return `${d}d ago`;
}
